module.exports = __webpack_public_path__ + "static/media/h12_mtev.53e93aca.webp";